module.exports = __webpack_public_path__ + "static/media/2015 - 2016 theme logo.dff46547.jpg";